import React, { useEffect, useRef, useState } from 'react'
import cssAudioRecordingWindow from './AudioRecordingWindow.module.scss'
import {WebAudioRecorderLibs, ClientGatewayInPackage, GlobalLibs, PackageVariablesLibs} from 'bc-react-package'

import './AudioRecordingWindow.css'

import Slider from '@material-ui/core/Slider'

const COMP_NAME = "AudioRecordingWindow"

// #region Constant
const WAVE_CHART_COUNT = 100
const AUDIO_RECORDING_DURATION_LIMIT = 300 // 在 WebAudioRecorder 不指定 DurationLimit 預設最長可錄音為 300s
const SLIDER_SLICE_COUNT = 100
// #endregion Constant

// #region Enumeration
const PageModeEnum = {
    "AudioRecord": 1,
    "AudioPlay": 2
}

const PlayingStatusEnum = {
    "Playing": 2,
    "Paused": 3,
    "Stop": 4
}
const SliderStatusEnum = {
    "Change": 1,            // 正在改變
    "ChangeCommitted": 2    // Mouse up 改變完畢
}

const RecorderStatusEnum = {
    "NotReady": 1,
    "Ready": 2,
    "Recording": 3
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mstrAudioBase64Recorded = "" // 錄到的音檔內容
let mobjRecordingTimer = null // Recording Timer
let mintStateCurrentRecordingTime = 0 // 錄音中 音檔目前錄到第幾秒
let mfltStateAudioCurrentTime = 0.0 // 目前正在播放的音檔的時間
let mfltStateAudioDuration = 0.0 // 目前正在播放的音檔的所有時間
let mintMouseDownPlayingStatusTmp = 4 // PlayingStatusEnum.Stop // 按下 Slider 時 當時的播放狀態
// #endregion Member Variables

function AudioRecordingWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [pageMode, setPageMode] = useState(PageModeEnum.AudioRecord)

    const [recordStatus, setRecordStatus] = useState(RecorderStatusEnum.NotReady)
    const [currentRecordingTime, setCurrentRecordingTime] = useState(0) // 錄音中 音檔目前錄到第幾秒

    const [playingStatus, setPlayingStatus] = useState(PlayingStatusEnum.Stop) // 播放模式中 目前的播放狀態
    const [audioDuration, setAudioDuration] = useState(0) // 播放模式中 音檔長度的秒數
    const [audioCurrentTime, setAudioCurrentTime] = useState(0.0) // 播放模式中 音檔目前播放到第幾秒
    // #endregion Init State

    // #region Init Ref
    let mrefWebAudioRecorderCore = useRef(null)
    let mrefVoiceVolumeBar = useRef(null)

    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Ref

    if(window.gSession.App.InApp)
    {
        // window.ComponentFuncEntry.SoundPowerRef = AppSoundPowerHandler
        // window.ComponentFuncEntry.AudioRecordingResultRef = AppAudioRecordingResultHandler

        ClientGatewayInPackage.RegisterFuncRef4AppSoundPowerHandler(AppSoundPowerHandler)
        ClientGatewayInPackage.RegisterFuncRef4AppAudioRecordingResultHandler(AppAudioRecordingResultHandler)
    }

    // #region First Launch
    if (!mblnInitialized)
    {
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        mintStateCurrentRecordingTime = currentRecordingTime
    }, [currentRecordingTime])

    useEffect(() => {
        mfltStateAudioCurrentTime = audioCurrentTime
    }, [audioCurrentTime])

    useEffect(() => {
        mfltStateAudioDuration = audioDuration
    }, [audioDuration])
    

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        if (!window.gSession.App.InApp)
        {
            // Web
            InitWebAudioRecorderBegin()
        }
        else
        {
            // App
            setRecordStatus(RecorderStatusEnum.Ready)
        }

        RegisterAudioEvent()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        // 避免離開這個 LU 還收到 Web Audio Recoder 的 Callback
        if (mrefWebAudioRecorderCore.current !== null)
        {
            mrefWebAudioRecorderCore.current.UnregisterCallbackRef()
            mrefWebAudioRecorderCore.current = null
        }

        mrefWebAudioRecorderCore.current = null
        mblnInitialized = false
        mintMouseDownPlayingStatusTmp = PlayingStatusEnum.Stop   // 按下 Slider 時 當時的播放狀態

        if(window.gSession.App.InApp)
        {
            // window.ComponentFuncEntry.SoundPowerRef = null
            // window.ComponentFuncEntry.AudioRecordingResultRef = null
            ClientGatewayInPackage.UnregisterFuncRef4AppSoundPowerHandler()
            ClientGatewayInPackage.UnregisterFuncRef4AppAudioRecordingResultHandler()
        }
    }

    // #endregion Painted Me

    // #region OnTapHandler
    function CheckOnTapHandler()
    {
        console.log(COMP_NAME + ".CheckOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // Stop audio
        window.AudioLibs.StopAudio()

        UnregisterAudioEvent()

        let objCallbackData = {
            "Action": "AudioRecordingWindowCloseWithResult",
            "AudioBase64": mstrAudioBase64Recorded
        }
        props.CallbackRef(objCallbackData)
    }

    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // Stop audio
        window.AudioLibs.StopAudio()

        UnregisterAudioEvent()

        let objCallbackData = {
            "Action": "AudioRecordingWindowCloseWithoutResult"
        }
        props.CallbackRef(objCallbackData)
    }

    function RecordStartOnTapHandler()
    {
        console.log(COMP_NAME + ".RecordStartOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (!window.gSession.App.InApp)
        {
            // Web
            setRecordStatus(RecorderStatusEnum.Recording)
            mstrAudioBase64Recorded = ""
            mrefWebAudioRecorderCore.current.CallWebAudioRecorderToStart()

            mobjRecordingTimer = setInterval(
                function ()
                {
                    console.log("RecordStartOnTapHandler.mintStateCurrentRecordingTime: ", mintStateCurrentRecordingTime)
                    setCurrentRecordingTime(mintStateCurrentRecordingTime + 1)
                },
                1000);
        }
        else
        {
            console.log("App Start Audio")
            // App
            if (window.gSession.App.iOSNewGateway)
            {
                console.log("iOSNewGateway Start Audio")
                // SwiftUI
                CallAppStartAudioRecording()
                setRecordStatus(RecorderStatusEnum.Recording)

                mobjRecordingTimer = setInterval(
                    function ()
                    {
                        console.log("RecordStartOnTapHandler.mintStateCurrentRecordingTime: ", mintStateCurrentRecordingTime)
                        setCurrentRecordingTime(mintStateCurrentRecordingTime + 1)
                    },
                    1000);
            }
            else
            {
                // 舊版的Swift 使用AppUI 不會跑到此
            }
        }
    }

    /*
    // 使用App的UI 開始錄音時 收到App回傳的結果
    function BackFromAppCallbackStartAudioRecording(ReturnData)
    {
        console.log(COMP_NAME + ".BackFromAppCallbackStartAudioRecording: ", ReturnData)
    }

    // 使用App的UI 停止錄音時 收到App回傳的結果
    function BackFromAppCallbackStopAudioRecording(ReturnData)
    {
        console.log(COMP_NAME + ".BackFromAppCallbackStopAudioRecording: ", ReturnData)
    }
    */

    /*===========================================
    summary: App錄音使用Web的UI 開始錄音
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppStartAudioRecording()
    {
        console.log(COMP_NAME + ".CallAppOpenAudioRecorder: ")

        // and call App to open Audio Recorder
        var intAction = window.gConst.ACTION_START_AUDIO_RECORDING;
        let strQueryString = "Action=" + intAction // "&Credential=" + window.gSession.Acc.Credential

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of CallAppOpenAudioRecorder

    // 錄音使用App的UI
    function StopRecordingTimer()
    {
        console.log(COMP_NAME + ".StopRecordingTimer")
        clearInterval(mobjRecordingTimer)
        setCurrentRecordingTime(0)
    }

    function RecordStopOnTapHandler()
    {
        console.log(COMP_NAME + ".RecordStopOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (!window.gSession.App.InApp)
        {
            // Web
            mrefWebAudioRecorderCore.current.CallWebAudioRecorderToStop()
            setRecordStatus(RecorderStatusEnum.Ready)
            StopRecordingTimer()
        }
        else
        {
            console.log("App Stop Audio")
            // App
            if (window.gSession.App.iOSNewGateway)
            {
                // SwiftUI
                console.log("iOSNewGateway Stop Audio")

                CallAppStopAudioRecording()
            }
            else
            {
                // 舊版的Swift 使用AppUI 不會跑到此
            }
        }
    }

    /*===========================================
    summary: App錄音使用Web的UI 停止錄音
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppStopAudioRecording()
    {
        console.log(COMP_NAME + ".CallAppStopAudioRecording: ")

        // and call App to open Audio Recorder
        var intAction = window.gConst.ACTION_STOP_AUDIO_RECORDING;
        let strQueryString = "Action=" + intAction

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of CallAppOpenAudioRecorder


    function PlayAudioOnTapHandler(StatePlayingStatus)
    {
        console.log(COMP_NAME + ".PlayAudioOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StatePlayingStatus === PlayingStatusEnum.Stop)
        {
            // 從頭播放
            setPlayingStatus(PlayingStatusEnum.Playing)
            window.AudioLibs.PlayAudio(mstrAudioBase64Recorded)
        }
        else if (StatePlayingStatus === PlayingStatusEnum.Paused)
        {
            // 繼續播放
            setPlayingStatus(PlayingStatusEnum.Playing)
            window.AudioLibs.Play()
        }

    }

    function PauseAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".PauseAudioOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.PauseAudio()
        setPlayingStatus(PlayingStatusEnum.Paused)
    }

    function DeleteAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".DeleteAudioOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        mstrAudioBase64Recorded = ""
        setPageMode(PageModeEnum.AudioRecord)
    }
    // #endregion OnTapHandler



    // #region Other Event Handler

    // 單純錄音時 錄音結果跟錯誤
    function AppAudioRecordingResultHandler(ReturnData)
    {
        console.log(COMP_NAME + ".AppAudioRecordingResultHandler: ", ReturnData)

        if (
            (typeof (ReturnData.ClosedBy) !== "undefined") &&
            (ReturnData.ClosedBy !== null)
        )
        {
            let intClosedBy = parseInt(ReturnData.ClosedBy)
            // 0: Audio Recorded Successfully
            // -1: Microphone access denied 
            // -99: Other Errors  

            let strAlertTitle = ""
            let strAlertBody = ""

            if (intClosedBy === 0)
            {
                // 0: Audio Recorded Successfully
                if (
                    (typeof (ReturnData.AudioRecorded) !== "undefined") &&
                    (ReturnData.AudioRecorded !== null) &&
                    (ReturnData.AudioRecorded !== "")
                )
                {
                    mstrAudioBase64Recorded = "data:audio/mp3;base64," + ReturnData.AudioRecorded
                }
                console.log("mstrAudioBase64Recorded: ", mstrAudioBase64Recorded)

                if (mstrAudioBase64Recorded !== "")
                {
                    setPageMode(PageModeEnum.AudioPlay)
                    // window.AudioLibs.PreloadAudio(mstrAudioBase64Recorded)
                    window.AudioLibs.SetAudioSrc(mstrAudioBase64Recorded, true)
                }

                // 若使用者錄音過程中 直接按Home離開 就沒有點擊StopOnTapHandler 所以在此改狀態
                setRecordStatus(RecorderStatusEnum.Ready)
                StopRecordingTimer()
            }
            else if (intClosedBy === -1)
            {
                // -1: Microphone access denied 
                strAlertTitle = window.gAppUI.MSG_Alert_Title_AudioRecordingError
                strAlertBody = window.gAppUI.MSG_Alert_MicrophoneAccessDenied + " (ClosedBy:" + intClosedBy.toString() + ")"
            }
            else if (intClosedBy === -99)
            {
                // -99: Other Errors 
                strAlertTitle = window.gAppUI.MSG_Alert_Title_AudioRecordingError
                strAlertBody = window.gAppUI.MSG_Alert_Msg_AppAudioRecordingUnknownError + " (ClosedBy:" + intClosedBy.toString() + ")"
            }

            if (intClosedBy < 0)
            {
                // 有錯誤
                setRecordStatus(RecorderStatusEnum.Ready)
                StopRecordingTimer()

                let objAlertObject = {
                    Header: strAlertTitle,
                    Body: strAlertBody,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            }
        }
    }

    // 單純錄音時 聲音大小的數值
    function AppSoundPowerHandler(ReturnData)
    {
        console.log(COMP_NAME + ".AppSoundPowerHandler: ", ReturnData)

        if (
            (typeof (ReturnData.SoundPower) !== "undefined") &&
            (ReturnData.SoundPower !== null)
        )
        {
            let intAverage = parseInt(ReturnData.SoundPower)
            StartVoiceVolumeBar(intAverage)
        }
    }

    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler: ")
        // setAudioCurrentTime(0.0) // 跳回到原點
        console.log("mfltStateAudioDuration:", mfltStateAudioDuration)
        setAudioCurrentTime(mfltStateAudioDuration) // 停在最後
        
        setPlayingStatus(PlayingStatusEnum.Stop)
    }

    function AudioDurationChangedHandler(Duration)
    {
        console.log(COMP_NAME + ".AudioDurationChangedHandler: ", Duration)
        setAudioDuration(Duration)
    }

    function AudioTimeUpdatedHandler(CurrentTime)
    {
        console.log(COMP_NAME + ".AudioTimeUpdatedHandler: ", CurrentTime)

        if (Math.ceil(mfltStateAudioCurrentTime) !== Math.ceil(CurrentTime))
        {
            setAudioCurrentTime(CurrentTime)
        }
    }
    // #endregion Other Event Handler

    // #region App Callback

    /*
    function AppCallback(ReturnData, CallAction)
    {
        console.log(COMP_NAME + ".AppCallback: ", ReturnData)

        if (CallAction === window.gConst.ACTION_START_AUDIO_RECORDING)
        {
            BackFromAppCallbackStartAudioRecording(ReturnData)
        }
        else if (CallAction === window.gConst.ACTION_STOP_AUDIO_RECORDING)
        {
            BackFromAppCallbackStopAudioRecording(ReturnData)
        }
    }
    */

    // #endregion App Callback

    // #region LoadingMask and Alert
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }

        props.CallbackRef(objCallbackData)
    }

    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    }

    function ShowAlert(AlertObject)
    {
        console.log(COMP_NAME + ".ShowAlert")

        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion LoadingMask and Alert

    function InitWebAudioRecorderBegin()
    {
        console.log(COMP_NAME + ".InitWebAudioRecorderBegin: ")

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_InitWebAudioRecording)
    }

    function InitWebAudioRecorderEnd(Successfully, ErrorCode, ErrorMsg)
    {
        console.log(COMP_NAME + ".InitWebAudioRecorderEnd: ", Successfully, ErrorCode, ErrorMsg)

        if (Successfully)
        {
            console.log("處理WebAudioRecorder初始化成功")
            setRecordStatus(RecorderStatusEnum.Ready)
        }
        else
        {
            console.log("處理WebAudioRecorder初始化失敗")
            setRecordStatus(RecorderStatusEnum.NotReady)

            if (mrefWebAudioRecorderCore.current !== null)
            {
                mrefWebAudioRecorderCore.current.UnregisterCallbackRef()
                mrefWebAudioRecorderCore.current = null
            }

            // 增加 桌上型電腦 偵測不到麥克風裝置 錯誤訊息判斷      Tim21.10.26
            let strBody = ""
            if (
                (typeof (ErrorCode) !== "undefined") &&
                (ErrorCode !== null)
            )
            {
                if (ErrorCode === WebAudioRecorderLibs.WARErrorEnum.WAR_ERROR_INIT_SETTING_ALLOW_MICROPHONE_ACCESS)
                {
                    strBody = window.gAppUI.MSG_Alert_Msg_WebAudioRecorderInitErr
                }
                else if (ErrorCode === WebAudioRecorderLibs.WARErrorEnum.WAR_ERROR_INIT_DETECT_MICROPHONE)
                {
                    // -1 // 桌上型電腦 偵測不到麥克風裝置
                    strBody = window.gAppUI.MSG_Alert_Msg_WebAudioRecorderDetectMicrophone
                }
                else
                {
                    strBody = ErrorCode.toString()
                    if (
                        (typeof (ErrorMsg) !== "undefined") &&
                        (ErrorMsg !== null) &&
                        (ErrorMsg !== "")
                    )
                    {
                        strBody = strBody + ": " + ErrorMsg
                    }
                }
            }

            let objAlertObject = {
                Header: window.gAppUI.MSG_Alert_Title_WebAudioRecorderInitErr,
                Body: strBody,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }
    }

    function WebAudioRecorderCoreCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".WebAudioRecorderCoreCallback: ", CallbackObj)

        if (CallbackObj.Action === 'WebAudioRecorderReportReady')
        {
            console.log("Web Audio Recorder Inited")
            CloseLoadingMask()
            InitWebAudioRecorderEnd(true, null, null)
        }
        else if (CallbackObj.Action === 'WebAudioRecorderReportInitErr')
        {
            console.log("Web Audio Recorder Init Err")
            CloseLoadingMask()
            InitWebAudioRecorderEnd(false, CallbackObj.ErrorCode, CallbackObj.ErrorMsg)
        }
        else if (CallbackObj.Action === 'WebAudioRecorderClosed')
        {
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderClosed", mstrAudioBase64Recorded)
            mstrAudioBase64Recorded = CallbackObj.AudioBase64

            ResetVoiceVolumeBar()

            if (mstrAudioBase64Recorded !== "")
            {
                setPageMode(PageModeEnum.AudioPlay)
                // window.AudioLibs.PreloadAudio(mstrAudioBase64Recorded)
                window.AudioLibs.SetAudioSrc(mstrAudioBase64Recorded, true)
            }
        }
        else if (CallbackObj.Action === 'WebAudioRecorderUpdateWaveChart')
        {
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderUpdateWaveChart: ", CallbackObj)
            WebAudioRecorderUpdateWaveChart(CallbackObj.WaveChartArray)
        }
        // else if (CallbackObj.Action === 'WebAudioRecorderEndStreaming')
        // {
        //     console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderEndStreaming CallbackObj: ", CallbackObj)
        //     console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderEndStreaming AudioBase64: ", CallbackObj.AudioBase64.length)
        //     if (CallbackObj.CallbackObject !== null)
        //     {
        //         console.log("這個回傳是正常 SR 結果! 例如：SROnEnd!")
        //     }
        //     else
        //     {
        //         console.log("這個回傳不是正常 SR 結果的結束! 例如：SRNoResult!")
        //     }
        // }
        else if (CallbackObj.Action === 'WebAudioRecorderError')
        {
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderError")
        }
    }

    function WebAudioRecorderUpdateWaveChart(WaveChartArray)
    {
        console.log(COMP_NAME + ".WebAudioRecorderUpdateWaveChart: ", WaveChartArray);

        let intAverage = GetWebAudioAverate(WaveChartArray)
        StartVoiceVolumeBar(intAverage)
    }

    // #region Other Functions

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent: ")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioDurationChangedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)
        window.AudioLibs.RegisterEventHandlerRef(AudioTimeUpdatedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)
    }

    function UnregisterAudioEvent()
    {
        console.log(COMP_NAME + ".UnregisterAudioEvent: ")
        // 避免離開這個 LU 還收到 Audio Player 的 Callback
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)
    }

    function GetWebAudioAverate(WaveChartArray)
    {
        console.log(COMP_NAME + ".GetWebAudioAverate: ", WaveChartArray)

        let i = 0;
        let intTotal = 0;
        let intAverage = 0;

        for (i = 0; i < WAVE_CHART_COUNT; i++)
        {
            intTotal += WaveChartArray[i];
        }
        intAverage = Math.floor(intTotal / WAVE_CHART_COUNT);

        if (intAverage > WAVE_CHART_COUNT)
        {
            intAverage = WAVE_CHART_COUNT;
        }

        console.log("WebAudioRecorderUpdateWaveChart.intAverage:", intAverage)

        return intAverage
    }

    function StartVoiceVolumeBar(intAverage)
    {
        console.log(COMP_NAME + ".StartVoiceVolumeBar: ", intAverage)

        if (mrefVoiceVolumeBar.current !== null)
        {
            // 已Render出來mrefVoiceVolumeBar
            let arrVoiceVolumeBarElements = mrefVoiceVolumeBar.current.querySelectorAll("div")
            console.log("arrVoiceVolumeBarElements.length:", arrVoiceVolumeBarElements.length)

            if (arrVoiceVolumeBarElements.length > 0)
            {
                let i
                for (i = 0; i < intAverage; i++)
                {
                    arrVoiceVolumeBarElements[i].style.backgroundColor = "transparent";
                }

                let j
                for (j = intAverage; j < WAVE_CHART_COUNT; j++)
                {
                    arrVoiceVolumeBarElements[j].style.backgroundColor = "#FFFFFF";
                }
            }
        }
    }

    function ResetVoiceVolumeBar()
    {
        console.log(COMP_NAME + ".ResetVoiceVolumeBar")
        if (mrefVoiceVolumeBar.current !== null)
        {
            let arrVoiceVolumeBarElements = mrefVoiceVolumeBar.current.querySelectorAll("div")
            console.log("arrVoiceVolumeBarElements.length:", arrVoiceVolumeBarElements.length)

            let i
            for (i = 0; i < arrVoiceVolumeBarElements.length; i++)
            {
                arrVoiceVolumeBarElements[i].style.backgroundColor = "#FFFFFF"
            }
        }
    }

    function GetRecordingTimeText(StateRecordStatus)
    {
        console.log(COMP_NAME + ".GetRecordingTimeText: ", StateRecordStatus)
        let strAudioTime = ""
        if (StateRecordStatus === RecorderStatusEnum.Recording)
        {
            let intMinuteAudioDuration = Math.floor(AUDIO_RECORDING_DURATION_LIMIT / 60);
            let intSecondAudioDuration = Math.floor(AUDIO_RECORDING_DURATION_LIMIT % 60);
            let strSecondAudioDuration = intSecondAudioDuration.PadLeft(2)
            let strAudioDuration = intMinuteAudioDuration + ":" + strSecondAudioDuration

            let intMinuteAudioCurrentTime = Math.floor(currentRecordingTime / 60);
            let intSecondAudioCurrentTime = Math.floor(currentRecordingTime % 60);
            let strSecondAudioCurrentTime = intSecondAudioCurrentTime.toString().PadLeft(2)
            let strAudioCurrentTime = intMinuteAudioCurrentTime.toString() + ":" + strSecondAudioCurrentTime

            strAudioTime = strAudioCurrentTime + " / " + strAudioDuration
        }
        return strAudioTime
    }
    // #endregion Other Functions

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Render
    /*===========================================
    summary: 增加Web 只有 Safari 錄音 提示藍芽有問題 文字
    remarks: 000 Tim 2022/12/09 Create
    ===========================================*/
    function RenderAudioRecordMemoWrapper()
    {
        if (
            (!window.gSession.App.InApp) &&
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.Safari)
            )
        {
            return (
                <div className={cssAudioRecordingWindow.divAudioRecordMemo}>
                    {window.gAppUI.MSG_AudioRecordMemo}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAudioRecordMemoWrapper

    function RenderProgressBarItem()
    {
        console.log(COMP_NAME + ".RenderProgressBarItem: ")
        let arrBlock = []
        for (let i = 0; i < WAVE_CHART_COUNT; i++)
        {
            arrBlock.push(<div key={i} className={cssAudioRecordingWindow.divProgressBarItem}></div>)
        }
        return arrBlock
    }

    function RenderRecordButton(StateRecordStatus)
    {
        console.log(COMP_NAME + ".RenderRecordButton: ")

        let objBlockButton = null
        if (StateRecordStatus === RecorderStatusEnum.Recording)
        {
            objBlockButton = <div className={cssAudioRecordingWindow.btnSRStop} onClick={() => RecordStopOnTapHandler()}>
                <div className={cssAudioRecordingWindow.divSRStopIcon}></div>
            </div>
        }
        else if (StateRecordStatus === RecorderStatusEnum.NotReady)
        {
            objBlockButton = <div className={cssAudioRecordingWindow.btnSRStartDisable}>
                <div className={cssAudioRecordingWindow.divSRStartIcon}></div>
            </div>
        }
        else if (StateRecordStatus === RecorderStatusEnum.Ready)
        {
            objBlockButton = <div className={cssAudioRecordingWindow.btnSRStart} onClick={() => RecordStartOnTapHandler()}>
                <div className={cssAudioRecordingWindow.divSRStartIcon}></div>
            </div>
        }
        return objBlockButton
    }

    // remarks: 001 Tim 2022/06/14 增加Web 錄音 提示藍芽有問題 文字
    //          002 Tim 2022/12/09 調整 Web 只有 Safari 錄音 提示藍芽有問題 文字
    function RenderContentAreaForAudioRecord()
    {
        // console.log(COMP_NAME + ".RenderContentAreaForAudioRecord: ")
        return (
            <>
                {RenderRecordButton(recordStatus)}
                <div className={cssAudioRecordingWindow.divAudioRecordTimeArea}>{GetRecordingTimeText(recordStatus)}</div>
                <div ref={mrefVoiceVolumeBar} className={cssAudioRecordingWindow.divProgressBar}>
                    {RenderProgressBarItem()}
                </div>

                {RenderAudioRecordMemoWrapper()}
            </>
        )
    }

    /*
    function SliderOnChangeHandler(event, value)
    {
        console.log(COMP_NAME + ".SliderOnChangeHandler", value)
        console.log("SliderOnChangeHandler.event.target.value:", event.target.value)

        let floatCurrentTime = parseFloat(event.target.value / SLIDER_SLICE_COUNT)
        console.log("floatCurrentTime: ", floatCurrentTime)
        setAudioCurrentTime(floatCurrentTime)
        window.AudioLibs.SetCurrentTime(floatCurrentTime)

        if (playingStatus === PlayingStatusEnum.Stop)
        {
            // 下次播放 要從特定時間點開始播放 不是從頭開始播放
            setPlayingStatus(PlayingStatusEnum.Paused)
        }
    }
    */

    /*===========================================
    summary: Slider元件 改變數值事件
    remarks: 000 Tim 2022/02/25 Create
    ===========================================*/
    function SliderOnChangeHandler(event, value, StatePlayingStatus, SliderStatus)
    {
        // console.log(COMP_NAME + ".SliderOnChangeHandler: event: ", event)
        // console.log(COMP_NAME + ".SliderOnChangeHandler value: ", value)
        // console.log(COMP_NAME + ".SliderOnChangeHandler StatePlayingStatus: ", StatePlayingStatus)
        // console.log(COMP_NAME + ".SliderOnChangeHandler SliderStatus: ", SliderStatus)

        let fltCurrentTime = parseFloat(value / SLIDER_SLICE_COUNT)
        // console.log(COMP_NAME + ".SliderOnChangeHandler fltCurrentTime: ", fltCurrentTime)
        setAudioCurrentTime(fltCurrentTime)
        window.AudioLibs.SetCurrentTime(fltCurrentTime)

        if (SliderStatus === SliderStatusEnum.Change)
        {
            // SliderStatusEnum.Change   1      // 正在改變
            mintMouseDownPlayingStatusTmp = StatePlayingStatus

            // 剛好是 第一下 按下去 Mouse Down
            if (
                (typeof (event) !== 'undefined') &&
                (event !== null) &&
                (typeof (event.type) !== 'undefined') &&
                (event.type !== null) &&
                (event.type === "mousedown")
            )
            {
                window.AudioLibs.PauseAudio()
            }
        }
        else if (SliderStatus === SliderStatusEnum.ChangeCommitted)
        {
            // SliderStatusEnum.ChangeCommitted     2    // Mouse up 改變完畢

            if (StatePlayingStatus === PlayingStatusEnum.Stop)
            {
                // 下次播放 要從特定時間點開始播放 不是從頭開始播放
                setPlayingStatus(PlayingStatusEnum.Paused)
            }

            // 如果按下 Slider 時 當時的播放狀態 是 播放中
            // 放開時 就接著播放
            // 如果 沒在播放 就不需要播     Tim22.02.25
            if (mintMouseDownPlayingStatusTmp === PlayingStatusEnum.Playing)
            {
                window.AudioLibs.Play()
            }
        }
    }

    function RenderContentAreaForAudioPlay()
    {
        console.log(COMP_NAME + ".RenderContentAreaForAudioPlay: ")

        let strAudioTime = ""
        if (audioDuration !== 0)
        {
            let intMinuteAudioDuration = Math.floor(audioDuration / 60);
            let intSecondAudioDuration = Math.floor(audioDuration % 60);
            let strSecondAudioDuration = intSecondAudioDuration.toString().PadLeft(2)
            let strAudioDuration = intMinuteAudioDuration + ":" + strSecondAudioDuration

            let intMinuteAudioCurrentTime = Math.floor(audioCurrentTime / 60);
            let intSecondAudioCurrentTime = Math.floor(audioCurrentTime % 60);
            let strSecondAudioCurrentTime = intSecondAudioCurrentTime.toString().PadLeft(2)
            let strAudioCurrentTime = intMinuteAudioCurrentTime.toString() + ":" + strSecondAudioCurrentTime

            strAudioTime = strAudioCurrentTime + " / " + strAudioDuration
        }

        let objBlockPlayPauseButtonArea = null
        if (playingStatus === PlayingStatusEnum.Playing)
        {
            objBlockPlayPauseButtonArea = <div className={cssAudioRecordingWindow.btnPauseAudio} onClick={() => PauseAudioOnTapHandler()}>
                <div className={cssAudioRecordingWindow.divPauseAudioIcon}></div>
            </div>
        }
        else
        {
            objBlockPlayPauseButtonArea = <div className={cssAudioRecordingWindow.btnPlayAudio} onClick={() => PlayAudioOnTapHandler(playingStatus)}>
                <div className={cssAudioRecordingWindow.divPlayAudioIcon}></div>
            </div>
        }

        // Slider custom style
        // Ref: https://mui.com/components/slider/#music-player
        // let objSliderTheme = {
        //     width: "112px",
        //     // color: "#B1B1B1"
        //     // color: theme.palette.mode === 'dark' ? '#fff' : 'rgba(0,0,0,0.87)',
        //     // color: '#B1B1B1',
        //     color: 'rgb(255, 34, 34)',
        //     height: 4,
        //     // "& .MuiSlider-thumb": {
        //     //     height: 24,
        //     //     width: 24,
        //     //     backgroundColor: "#fff",
        //     //     border: "2px solid currentColor",
        //     //     "&:before": {
        //     //       display: "none"
        //     //     }
        //     //   }
        //     // '& .MuiSlider-thumb': {
        //     //     width: 14,
        //     //     height: 14,
        //     //     backgroundColor: "#fff",
        //     //     boxShadow: "0 0 0 1px rgba(0,0,0,0.02)",
        //     //     // transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
        //     //     // '&:before': {
        //     //     //     display: "none",
        //     //     // },
        //     //     // '&:hover, &.Mui-focusVisible': {
        //     //     //     // boxShadow: `0px 0px 0px 8px ${theme.palette.mode === 'dark'
        //     //     //     //         ? 'rgb(255 255 255 / 16%)'
        //     //     //     //         : 'rgb(0 0 0 / 16%)'
        //     //     //     //     }`,
        //     //     //     boxShadow: "0 0 0 1px rgba(0,0,0,0.02)",
        //     //     // },
        //     //     // '&.Mui-active': {
        //     //     //     width: 14,
        //     //     //     height: 14,
        //     //     // },
        //     //     // "& .MuiSlider-track": {
        //     //     //     border: "none"
        //     //     //   },
        //     //     // "&:focus, &:hover, &:blur, &.Mui-active": {
        //     //     //     boxShadow:
        //     //     //         "0 0 0 1px rgba(0,0,0,0.02)",
        //     //     //     // Reset on touch devices, it doesn't add specificity
        //     //     //     "@media (hover: none)": {
        //     //     //         boxShadow: "0 0 0 1px rgba(0,0,0,0.02)"
        //     //     //     }
        //     //     // }
        //     // },
        //     // '& .MuiSlider-rail': {
        //     //     opacity: 0.28,
        //     // },
        // }
        console.log("audioCurrentTime:", audioCurrentTime)
        console.log("audioDuration:", audioDuration)
        let intValue = audioCurrentTime * SLIDER_SLICE_COUNT
        let intMax = audioDuration * SLIDER_SLICE_COUNT
        return (
            <>
                <div className={cssAudioRecordingWindow.divPlayDeleteArea}>
                    {objBlockPlayPauseButtonArea}
                    <div className={cssAudioRecordingWindow.divSliderArea}>
                        <Slider id="sliderAudioPlayer"
                            className={cssAudioRecordingWindow.sliderAudioPlayer}
                            value={intValue} defaultValue={0}
                            min={0} max={intMax}
                            valueLabelDisplay="off"
                            onChange={(event, value) => SliderOnChangeHandler(event, value, playingStatus, SliderStatusEnum.Change)}
                            onChangeCommitted={(event, value) => SliderOnChangeHandler(event, value, playingStatus, SliderStatusEnum.ChangeCommitted)}
                        />
                    </div>
                    <div className={cssAudioRecordingWindow.divAudioPlayTimeArea}>
                        {strAudioTime}
                    </div>
                    <div className={cssAudioRecordingWindow.btnDeleteAudio} onClick={() => DeleteAudioOnTapHandler()}>
                        <div className={cssAudioRecordingWindow.divDeleteAudioIcon}></div>
                    </div>
                </div>
            </>
        )
    }

    function CloseButton({ RecordStatus })
    {
        console.log(COMP_NAME + ".CloseButton: ", RecordStatus)

        function GetClsCloseButton()
        {
            // console.log(COMP_NAME + ".GetClsCloseButton: ")
            let objCls = null
            if (RecordStatus === RecorderStatusEnum.Recording)
            {
                objCls = cssAudioRecordingWindow.btnCloseDisable
            }
            else
            {
                objCls = cssAudioRecordingWindow.btnClose
            }
            return objCls
        }

        return <div className={GetClsCloseButton()} onClick={() => CloseOnTapHandler()}></div>
    }

    function CheckButton({ RecordStatus })
    {
        console.log(COMP_NAME + ".CheckButton: ")

        function GetClsCheckButton()
        {
            console.log(COMP_NAME + ".GetClsCloseButton: ")
            let objCls = null
            if (
                (RecordStatus === RecorderStatusEnum.Recording) || // 錄音中不給按
                (mstrAudioBase64Recorded === "") // 無錄音檔時 不給按
            )
            {
                objCls = cssAudioRecordingWindow.btnCheckDisable
            }
            else
            {
                objCls = cssAudioRecordingWindow.btnCheck
            }
            return objCls
        }

        return (
            <div className={GetClsCheckButton()} onClick={() => CheckOnTapHandler()}></div>
        )
    }

    function RenderContentArea()
    {
        console.log(COMP_NAME + ".RenderContentArea: ")
        let objBlock = null
        if (pageMode === PageModeEnum.AudioRecord)
        {
            objBlock = RenderContentAreaForAudioRecord()
        }
        else if (pageMode === PageModeEnum.AudioPlay)
        {
            objBlock = RenderContentAreaForAudioPlay()
        }
        return (
            <div className={cssAudioRecordingWindow.divContentArea}>
                <div className={cssAudioRecordingWindow.divContent}>
                    {objBlock}
                </div>
                <CloseButton RecordStatus={recordStatus} />
                <CheckButton RecordStatus={recordStatus} />
            </div>
        )
    }

    function GenerateRecorderCore()
    {
        console.log(COMP_NAME + ".GenerateRecorderCore: ")

        let objWebAudioReorder = null
        if (!window.gSession.App.InApp)
        {
            objWebAudioReorder = <WebAudioRecorderLibs.WebAudioRecorderCore ref={mrefWebAudioRecorderCore}
                NeedUploadUserRecordedAudio={false} Credential={window.gSession.Acc.Credential} Env={window.gSession.App.Env}
                CallbackRef={WebAudioRecorderCoreCallback} />
        }

        return objWebAudioReorder
    }

    function RenderMain()
    {
        console.log(COMP_NAME + ".RenderMain: ")

        return (
            <div className={cssAudioRecordingWindow.divMaskArea}>
                {GenerateRecorderCore()}
                {RenderContentArea()}
            </div>
        )
    }

    return (
        <>
            {RenderMain()}
        </>
    )
    // #endregion Render
}

export default AudioRecordingWindow
